import { Api } from "@mcleod/core";
import { AutogenLayoutWireOpenItemsReport } from "./autogen/AutogenLayoutWireOpenItemsReport";
import { DataSourceExecutionEvent } from "@mcleod/components";

export class WireOpenItemsReport extends AutogenLayoutWireOpenItemsReport {

    private fuel_interface_id:string;
    private response:any;

    override onLoad() {
        this.getCardProvider();
    }

    async getCardProvider() {
        this.response = await Api.search("lme/dispatch/asset/fuel-interface-configured", {});

        if (this.response.actual_row_count === 1) {
            this.textboxCardProvider.required = false;
            this.textboxCardProvider.requiredDuringSearch = false;
            this.textboxCardProvider.visible = false;
            const data = this.response?.data?.[0];
            this.fuel_interface_id = data.id;
        }
    }

    /** This is an event handler for the beforeExecution event of sourceFuelDetail. */
    sourceWireOpenItemsBeforeExecution(event: DataSourceExecutionEvent) {
        if (this.fuel_interface_id) {
            event.filter.fuel_interface_id = this.fuel_interface_id;
        }
    }
}
